module.exports = __webpack_public_path__ + "img/icon_mouse_active.fa362cd9.svg";